import { useContext } from 'react';
import { UserPreferencesContext } from '@contexts';
import { SettingsIcon, DatabaseIcon, ConnectorsIcon, UsersIcon } from '@svgs';

// wrapper around left sidebar
export const SidebarWrapper = ({ children }) => {
  const [userPreferences, setUserPreferences] = useContext(
    UserPreferencesContext,
  );

  return (
    <div
      className={
        `sb-col sb-sidebar ` + (userPreferences.hideSidebar ? 'sb-hide' : '')
      }
    >
      {children}
    </div>
  );
};
